import { Flex, Center, Heading, Image } from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";

export default function Custom404() {
  const router = useRouter();
  const { brand, country, trackingcode } = router.query;

  const [errMsg, setErrMsg] = useState<string>(
    "The page you requested was not found"
  );

  useEffect(() => {
    if (!brand) {
      return setErrMsg("Invalid URL: Brand not found");
    }
    if (!country) {
      return setErrMsg("Invalid URL: Country not found");
    }
    if (!trackingcode) {
      return setErrMsg("Invalid URL: No Tracking Code");
    }
  }, [brand, country, trackingcode]);

  return (
    <Flex
      height="100vh"
      width="100vw"
      backgroundColor={"#F2F1EF"}
      overflowX="hidden"
      flexDir={"column"}
    >
      <Center flex="1" overflowY="auto" flexDir={"column"}>
        <Image src={"/img/404.png"} maxW={{ base: "30%", md: "20%" }} />
        <Heading>{errMsg}</Heading>
      </Center>
    </Flex>
  );
}
